import { render, staticRenderFns } from "./imageClassification.vue?vue&type=template&id=d22d0fe2&scoped=true"
import script from "./imageClassification.vue?vue&type=script&lang=js"
export * from "./imageClassification.vue?vue&type=script&lang=js"
import style0 from "./imageClassification.vue?vue&type=style&index=0&id=d22d0fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_react-dom@19.2.4_react@18.3.1_vue-templat_zb2mrinni5lndihrytzfraeym4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22d0fe2",
  null
  
)

export default component.exports